const FriendGetFriend = {
  path: "",
  name: "",
  redirect: "/friendgetfriend",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/friendgetfriend",
      redirect: "/friendgetfriend",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Friend Get Friend",
      meta: {
        requiresAuth: true,
        activeUrl: "/friendgetfriend",
        parent: "friendgetfriend",
        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/friendGetFriend/Index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/friendgetfriend",
            parent: "friendgetfriend",
            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "Friend Get Friend Detail",
          component: () => import("@/views/pages/friendGetFriend/Details"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/friendgetfriend",
            parent: "friendgetfriend",
            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default FriendGetFriend;
